import {selectUnits} from '../../redux/reducers/sharedStateReducer/selectors';

/**
 * Применилась ли способность отряда этим экшеном: до него отряд способность в
 * этом этапе не применял, а после — применил (hasUsedAbilityThisWarPhase,
 * общий флаг способностей фракций). Отвергнутая попытка (обучение не
 * пропустило экшен, правила отказали) состояния не меняет — ее итог
 * показывать нельзя
 *
 * @param {Object} prevState — состояние до экшена
 * @param {Object} nextState — после
 * @param {string} unitId
 * @returns {boolean}
 */
export const checkIfUnitAbilityApplied = (prevState, nextState, unitId) => {
  const findUnit = (state) => (selectUnits(state) || []).find((unit) => unit.id === unitId);
  const unitBefore = findUnit(prevState);
  const unitAfter = findUnit(nextState);
  return Boolean(unitBefore && unitAfter && !unitBefore.hasUsedAbilityThisWarPhase && unitAfter.hasUsedAbilityThisWarPhase);
};
